import RestApiModel from "@/api/Model/RestApiModel";

class CoverholderReferral extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderReferral';
  }
}

export default CoverholderReferral;
